<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:43
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:26:50
 * @FilePath: \mrc-base-frontend\src\views\enterprise\enterpriseInfo\index.vue
-->
<template>
  <div>
    <mrc_ess_iconGroup
      :is_disabled="disabled"
      :showEdit="hasBtn('edit-organizaiton-configuration')"
      :show_del="hasBtn('delete-organization-configuration')"
      @handleEdit="handleEdit"
      @handleDel="handleDel"
    ></mrc_ess_iconGroup>
    <v-tabs v-model="tab" @change="tabChange" background-color="#eeeef0" grow>
      <v-tab
        v-for="(item, index) in tablist"
        class="text-capitalize"
        :key="index"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, index) in tablist" :key="index">
        <keep-alive>
          <component
            :is="item.component"
            @changeiconStatus="handleEdit"
            :disabled="disabled"
            @cancel="handleCancel"
          ></component>
        </keep-alive>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import mailBox from "./mailBox";
import baseData from "./baseData";
import companyAttr from "./companyAttr";
import exchange from "./exchange";
import timeLanguage from "./time_lang_set";
import unit from "./unit";
import authenticationInformation from "./authenticationInformation";
import {
  add_update_baseData,
  del_baseData,
  find_baseData,
  get_company_del,
} from "@/service/api/company_set";
export default {
  // components: {mailBox,baseData,companyAttr,exchange,timeLanguage,unit},
  props: {},
  data() {
    return {
      tab: 0,
      disabled: false,
    };
  },
  created() {},
  mounted() {
    // console.log(this.$router.match(this.$route.fullPath).fullPath)
    this.tab = this.$store.state.tab;
    this.disabled = this.$store.state.iconstatus;
  },
  methods: {
    tabChange(val) {
      this.$store.commit("setTab", val);
      this.tab = this.$store.state.tab;
    },
    handleEdit() {
      this.$store.commit("set_iconstatus", !this.disabled);
      this.disabled = this.$store.state.iconstatus;
    },
    handleCancel(val) {
      this.disabled = val;
    },
    // 删除
    handleDel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_deletion"),
      })
        .then(async () => {
          const del = await get_company_del({
            uuid: this.$store.state.listObj.uuid,
          });
          if (del.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            if (
              this.$store.state.userData.userType != 1 &&
              this.$store.state.userData.userType != 4
            ) {
              await this.$store.dispatch("set_topcompanylist");
            }
            this.$router.push({
              name: "enterprise",
            });
          }
        })
        .catch(() => {});
      // this.$myConfirm({ content: '是否删除' })
      //   .then(async () => {
      //     const del = await del_baseData({
      //       org_level_uuid: this.params.org_level_uuid,
      //     })
      //     if (del.code == 200) {
      //       this.$Message({
      //         text: this.$t('message_The_deletion_was_successful'),
      //       })
      //       this.$router.go(-1)
      //     }
      //   })
      //   .catch(() => { })
    },
  },
  computed: {
    tablist() {
      return [
        { name: this.$t("label_The_unit_set"), component: unit },
        { name: this.$t("label_Basic_information"), component: baseData },
        {
          name: this.$t("label_Time_zone_and_language_Settings"),
          component: timeLanguage,
        },
        { name: this.$t("label_Exchange_rate_is_set"), component: exchange },
        { name: this.$t("label_Mailbox"), component: mailBox },
        {
          name: this.$t("label_Company_attribute_configuration"),
          component: companyAttr,
        },
        {
          name: this.$t("label_security_configuration"),
          component: authenticationInformation,
        },
      ];
    },
  },
  watch: {
    disabled: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_corporate_settings";
          this.$store.commit("set_page_title", "label_edit_corporate_settings");
        } else {
          this.$route.meta.title = "label_view_corporate_settings";
          this.$store.commit("set_page_title", "label_view_corporate_settings");
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    this.$store.commit("setTab", "");
  },
};
</script>

<style scoped></style>
